/** EN uses Swedish values until translated. */
import { newsTranslationsEn } from './newsTranslations'

export const pagesNewsEn = {
    title: 'News',
    loadingNews: 'Loading news...',
    ...newsTranslationsEn,
}
